module.exports = __webpack_public_path__ + "img/step-3.8d27cacb.png";